import { toast } from 'sonner';
import { useUpdatePassbook, type PassbookFlagKey, type PassbookPermissionRow } from '../api/use-permissions';
import { passbookPageFlagGroups } from '../model/page-flags';
import { FlagGrid, FlagRow, FlagSection } from './flag-table';

/** Páginas do menu da loja que valem para todos os usuários do passbook. */
export function PageFlagsTable({ passbook }: { passbook: PassbookPermissionRow }) {
  const update = useUpdatePassbook(passbook.id);

  const toggle = (key: PassbookFlagKey, label: string, next: boolean) => {
    update.mutate(
      { flags: { [key]: next } },
      {
        onSuccess: () => toast.success(`${label} ${next ? 'liberada' : 'bloqueada'}.`),
        onError: () => toast.error(`Não deu para alterar ${label}.`),
      },
    );
  };

  return (
    <FlagGrid>
      {passbookPageFlagGroups(passbook).map((group) => (
        <FlagSection key={group.section} title={group.section}>
          {group.flags.map((flag) => (
            <FlagRow
              key={flag.key}
              id={`flag-${passbook.id}-${flag.key}`}
              label={flag.label}
              effect={flag.effect}
              checked={passbook.flags[flag.key]}
              onCheckedChange={(next) => toggle(flag.key, flag.label, next)}
            />
          ))}
        </FlagSection>
      ))}
    </FlagGrid>
  );
}
